import * as React from 'react';
var defaults = {
    context: {}
};
var PlatformContext = React.createContext(defaults);
/**
 * Provider component for supplying the common BexApi data to your React tree.
 * This data can be read with the `usePlatformContext()` hook in your function components.
 */
export var PlatformContextProvider = function (props) {
    var children = props.children, context = props.context;
    var value = { context: context };
    return React.createElement(PlatformContext.Provider, { value: value }, children || null);
};
PlatformContextProvider.displayName = 'PlatformContextProvider';
export var usePlatformContext = function () {
    return React.useContext(PlatformContext);
};
//# sourceMappingURL=platform-context-provider.js.map